/* eslint-disable no-console */
/* eslint-disable global-require */
import {
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
  ReactRouterVersion,
} from '@grafana/faro-react';
import { Route } from 'react-router-dom';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

// Función para obtener la configuración según el ambiente
const getFaroConfig = () => {
  const { hostname } = window.location;

  // Detectar ambiente basado en hostname
  let environment: string;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    environment = 'development';
  } else if (hostname.includes('test')) {
    environment = 'testing';
  } else {
    environment = 'production';
  }

  // Verificar si Faro está habilitado para este ambiente
  const faroEnabled = process.env.REACT_APP_FARO_ENABLED === 'true';

  return {
    environment,
    faroUrl: process.env.REACT_APP_FARO_ENDPOINT || '',
    appName: process.env.REACT_APP_NAME || '',
    appVersion: process.env.REACT_APP_VERSION || '',
    enabled: faroEnabled,
  };
};

export const initFaro = () => {
  const config = getFaroConfig();

  // Verificar si Faro está habilitado
  if (!config.enabled) {
    console.info(`🔕 Faro deshabilitado para ambiente: ${config.environment}`);
    return null;
  }

  // Solo inicializar si tenemos URL de Faro configurada
  if (!config.faroUrl) {
    console.warn(
      `Faro URL no configurada para ambiente: ${config.environment}`,
    );
    return null;
  }

  try {
    const faro = initializeFaro({
      url: config.faroUrl,
      app: {
        name: config.appName,
        version: config.appVersion,
        environment: config.environment,
      },
      instrumentations: [
        // Instrumentaciones web automáticas
        ...getWebInstrumentations({
          captureConsole: true,
          captureConsoleDisabledLevels: [], // Captura todos los niveles de console
        }),

        // Integración con React Router v5
        new ReactIntegration({
          router: {
            version: ReactRouterVersion.V5,
            dependencies: {
              history: require('history'),
              Route,
            },
          },
        }),

        // Trazado de instrumentación
        new TracingInstrumentation(),
      ],

      // Configuración de sesión
      sessionTracking: {
        enabled: true,
        persistent: true,
      },
    });

    console.info(
      `✅ Faro inicializado correctamente para ambiente: ${config.environment} con url: ${config.faroUrl}`,
    );
    return faro;
  } catch (error) {
    console.error('❌ Error al inicializar Faro:', error);
    return null;
  }
};

export default initFaro;
